import { render, staticRenderFns } from "./ChangeCorpManger.vue?vue&type=template&id=0a5ceaf6&"
import script from "./ChangeCorpManger.vue?vue&type=script&lang=js&"
export * from "./ChangeCorpManger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports